import { type StateCreator, create } from 'zustand';
import { devtools } from 'zustand/middleware';

import type { OrderUpdateCommand } from '@repo/types/order-update';

export interface PendingAssetSubmission {
    id: string;
    submission: {
        type: 'orderUpdate';
        payload: OrderUpdateCommand;
    };
}

export const EMPTY_PENDING_SUBMISSIONS: PendingAssetSubmission[] = [];

interface AssetEditState {
    assetId: string | undefined;
    pendingSubmissions: PendingAssetSubmission[];
}

interface AssetEditActions {
    setPendingSubmissions: (assetId: string, pendingSubmissions: PendingAssetSubmission[]) => void;
    clearPendingSubmissions: () => void;
}

interface State extends AssetEditState, AssetEditActions {}

const storeName = 'asset-edit-store';

const createAssetEditStore: StateCreator<State, [['zustand/devtools', never]], [], State> = (set) => ({
    assetId: undefined,
    pendingSubmissions: EMPTY_PENDING_SUBMISSIONS,

    setPendingSubmissions: (assetId, pendingSubmissions) => {
        set({
            assetId: pendingSubmissions.length > 0 ? assetId : undefined,
            pendingSubmissions: pendingSubmissions.length > 0 ? pendingSubmissions : EMPTY_PENDING_SUBMISSIONS,
        });
    },
    clearPendingSubmissions: () => {
        set({ assetId: undefined, pendingSubmissions: EMPTY_PENDING_SUBMISSIONS });
    },
});

export const useAssetEditStore = create<State>()(
    devtools(createAssetEditStore, {
        name: storeName,
    })
);
